import { Icon } from "@dmm-com/rocket-web-ui-library";
import { useMemo } from "react";
import * as Styled from "./style";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { useAuth } from "~/provider/auth";

type UserPointProps = {
  /** user menu非表示処理 */
  onHideUserMenu: () => void;
};

export const UserPoint = ({ onHideUserMenu }: UserPointProps) => {
  const { isLoggedIn, wallet } = useAuth();

  const totalPoint = useMemo(() => {
    if (wallet === undefined) return 0;
    const {
      dmmPoint: { paidDmmPoint, sharedFreeDmmPoint },
    } = wallet;
    return paidDmmPoint + sharedFreeDmmPoint;
  }, [wallet?.dmmPoint]);

  if (!isLoggedIn) return null;

  return (
    <Styled.DivContainer>
      <Styled.DivPointContainer
        onClick={() => {
          window.open(URL.pointClub, "_blank");
        }}
      >
        <Styled.ParContentsHead>総保有ポイント</Styled.ParContentsHead>
        <Styled.ParContentsValue>
          <span>{totalPoint.toLocaleString()}</span> pt
        </Styled.ParContentsValue>
      </Styled.DivPointContainer>
      <Styled.DivWrapper>
        <Styled.ButtonIconWrapper
          type="button"
          name="addPoint"
          aria-label="addPoint"
          onClick={() => {
            onHideUserMenu();
            window.location.href = URL.pointCharge;
          }}
        >
          <Icon name="signPlus" color="GRAY50" size="M" />
        </Styled.ButtonIconWrapper>
      </Styled.DivWrapper>
    </Styled.DivContainer>
  );
};
